import { render, staticRenderFns } from "./ServicesReservationAddedServiceAdd.vue?vue&type=template&id=0e0b4bcb&scoped=true&"
import script from "./ServicesReservationAddedServiceAdd.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationAddedServiceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0b4bcb",
  null
  
)

export default component.exports